'use strict'
module.exports = {
  BASE_PATH: '/',
  BACKEND_URL: 'https://test.conasi365.vn/app-living/',
  GROUP_CHANNEL: {
    name: 'group_channel_',
    check_notification: 'send_push_notification',
    ws: "ws"
  },
  SITE_NAME_INFO: 4 // 1: Apartment, 2: Conasi, 3: Tropicana Garden, 4: Apollo Home
};



//////////////////
// WEBPACK FOOTER
// ./build/config.js
// module id = c0zf
// module chunks = 0